import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import config from '../config.js'
import { Loader } from '../components/loader'

export default function Logout() {
    const[loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const sessionDestroy = async() => {
        await fetch(`${config.apiPath}logout.php`);
        setLoading(false);
        navigate('/');
    }
    useEffect(() => {
        sessionDestroy();
    }, [sessionDestroy]);

    if(loading) return <Loader />
}